(function () {
    "use strict";
    angular.module("app").controller("RequestCommentsController", CommentsController);

    CommentsController.$inject = ["$scope", "commentsService",];
    function CommentsController($scope, commentsService) {
        const subscription = commentsService.Request$.subscribe(function onNext(d) { if (d) $scope.comments = d; });

        this.$onDestroy = function () {
            subscription.dispose();
        };
    }
})();